import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { toastr } from 'react-redux-toastr';

import { setLoader, removeLoader } from '../../../actions';
import CampaignDetails from './create/CampaignDetails';
import { AdvertiserApi } from '../../../api';
import { convertDollarsToMills } from '../../../utils/helpers/currency';

class Edit extends Component {
  onFormSubmit(values) {
    const { dispatch, account, campaign, handleHide } = this.props;
    const args = [account.uuid, values.id, {
      ...values,
      budget: convertDollarsToMills(values.budget)
    }];
    dispatch(setLoader('EditCampaignForm'));
    dispatch(AdvertiserApi.actions.standardCampaignUpdate.patch(...args, (error, success) => {
      dispatch(removeLoader('EditCampaignForm'));

      if (success) {
        dispatch({
          type: AdvertiserApi.events.standardCampaign.actionSuccess,
          syncing: false,
          data: { ...campaign, data: success.data }
        });
        toastr.success('Campaign Updated Successfully');
        handleHide();
      }

      if (error) {
        toastr.error(error.responseJSON.message);
      }
    }));
  }

  render() {
    const { show, handleHide, heading, handleSubmit, isLoading, formAction, form } = this.props;
    return (
      <Modal
        show={show}
        onHide={handleHide}
      >
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Modal.Body>
            <CampaignDetails formAction={formAction} formName={form} />
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
              <Button
                type='submit'
                loading={isLoading}
                bsStyle='primary'
              >
              Save
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'campaignUpdateForm'
});

const ResourceModal = connectModal({
  name: 'EditCampaignModal'
});

const mapStateToProps = (state) => {
  const { loader } = state;
  const isLoading = loader.includes('campaignUpdateForm');
  return {
    isLoading
  };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(Edit)));
